<wl-invoice-payment-header
  [paymentHeader]="paymentHeader"
  [creditCardPayment]="creditCardPayment"
  [paymentTypes]="paymentTypes"
  [paymentSources]="paymentSources"
  (amountChanged)="amountChanged()"
  (paymentTypeSelected)="onPaymentTypeSelected()"
  [overpaying]="overpaying"
  [anyPaymentIsCreditCard]="anyInvoicePaymentIsCreditCard"
  [paymentTypeError]="paymentTypeError"
></wl-invoice-payment-header>

<div *ngIf="hasPaymentMissingType" class="warning">
  {{ 'revenue.multi-invoice-payment.missing-payment-type-warning' | translate | titlecase }}
</div>

<hr />

<div [hidden]="noOpenInvoicesFound">
  <div class="payment-row-container mv-10">
    <span>{{ 'invoices.invoice-builder.payment-tab.payment-to-apply' | translate | titlecase }}</span>
    <span class="cell-align-right">{{ 'invoices.invoice-builder.payment-tab.adjusted-amount-due' | translate | titlecase }}</span>
    <span class="cell-align-right">{{ 'revenue.invoice-selector.invoice-num-column-header' | translate | titlecase }}</span>
    <span>{{ 'invoices.invoice-builder.payment-tab.revenue-item' | translate | titlecase }}</span>
    <span>{{ 'invoices.invoice-builder.payment-tab.payment-type' | translate | titlecase }}</span>
  </div>
  <div class="mct-flex mct-row mct-justify-center mct-items-center"  >
    <wl-busy *ngIf="loading" [show]="loading" [isLarge]="true"></wl-busy>
  </div>
  <div class="payment-row-container mv-10" *ngFor="let payment of invoicePayments" [hidden]="loading">
    <input class="payment-to-apply-cell" type="number" [(ngModel)]="payment.Amount" />
    <span class="cell-align-right">{{ payment._lineItem.AdjustedAmountDue | currency: 'USD':'symbol' }}</span>
    <span class="cell-align-right">{{ payment.InvoiceNumber }}</span>
    <span> {{ payment._lineItem.Item }} </span>
    <p-select
      appendTo="body"
      optionLabel="PaymentType"
      dataKey="PaymentTypeId"
      placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
      [options]="getPaymentTypesForPayment(payment)"
      [style]="{ width: '100%' }"
      [(ngModel)]="payment._paymentType"
      [disabled]="isPaymentTypeLockedByHeader(payment)"
      [styleClass]="payment.Amount > 0 && !payment._paymentType ? 'error-border' : ''"
    ></p-select>
  </div>
  <div class="payment-row-container">
    <span>
      <strong>{{ paymentHeader.Amount | currency: 'USD':'symbol' }}</strong>
    </span>
    <span class="cell-align-right">
      <strong>{{ totalAdjustedAmountDue | currency: 'USD':'symbol' }}</strong>
    </span>
  </div>
</div>
<div [hidden]="!noOpenInvoicesFound">
  <div class="m-10 f-wb">
    {{ 'revenue.payments.no-open-invoices' | translate | titlecase }}
  </div>
</div>
<wl-invoice-modification
  [(showPrompt)]="showModificationPrompt"
  [itemName]="modificationItemName"
  [invoice]="invoiceToModify"
  (modificationClosed)="modificationClosed($event)"
  (invoiceModified)="invoiceModified()"
  #invoiceModification
></wl-invoice-modification>
